
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";

interface BillingSelectionProps {
  billingOption: "monthly" | "yearly";
  setBillingOption: (option: "monthly" | "yearly") => void;
}

const BillingSelection = ({ billingOption, setBillingOption }: BillingSelectionProps) => {
  return (
    <>
      <h3 className="font-semibold text-xl text-[#1B2F47] mb-4">Select Payment Terms</h3>
      <RadioGroup 
        defaultValue="yearly" 
        onValueChange={value => setBillingOption(value as "monthly" | "yearly")} 
        className="space-y-4"
      >
        <div className={`flex items-center space-x-4 p-6 border-2 rounded-lg transition-all duration-200 ${billingOption === "yearly" ? "border-[#1B2F47] bg-blue-50" : "border-gray-200 hover:border-gray-300"}`}>
          <RadioGroupItem value="yearly" id="yearly" />
          <Label htmlFor="yearly" className="flex-1">
            <div className="flex justify-between items-center">
              <span className="font-medium text-lg">Yearly Plan</span>
              <div className="text-right">
                <span className="font-bold text-xl text-[#1B2F47]">$290/year</span>
                <div className="text-green-600 text-sm font-medium">Save $58 (2 months free!)</div>
              </div>
            </div>
          </Label>
        </div>

        <div className={`flex items-center space-x-4 p-6 border-2 rounded-lg transition-all duration-200 ${billingOption === "monthly" ? "border-[#1B2F47] bg-blue-50" : "border-gray-200 hover:border-gray-300"}`}>
          <RadioGroupItem value="monthly" id="monthly" />
          <Label htmlFor="monthly" className="flex-1">
            <div className="flex justify-between items-center">
              <span className="font-medium text-lg">Monthly Plan</span>
              <div className="text-right">
                <span className="font-bold text-xl text-[#1B2F47]">$29/month</span>
                <div className="text-gray-600 text-sm font-medium">Cancel Anytime</div>
              </div>
            </div>
          </Label>
        </div>
      </RadioGroup>
    </>
  );
};

export default BillingSelection;
